import { render } from "./workbench.vue?vue&type=template&id=16cae5df&scoped=true&ts=true"
import script from "./workbench.vue?vue&type=script&lang=ts"
export * from "./workbench.vue?vue&type=script&lang=ts"

import "./workbench.vue?vue&type=style&index=0&id=16cae5df&scoped=true&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cae5df"]])

export default __exports__